/**
 * O título de um campo que **não** é `<label>`.
 *
 * Os campos da ficha usam `<label>`, e isso é certo para um `<input>`. Mas o
 * seletor de cor e o de desenho interno são grupos de botões: dentro de um
 * `<label>`, clicar no texto "Cor" aciona o primeiro botão — "Sem cor" — e
 * apaga a cor do componente sem ninguém ter escolhido isso.
 */

import type { ReactNode } from "react"

export function Rotulado({ rotulo, children }: { rotulo: string; children: ReactNode }) {
  return (
    <div role="group" aria-label={rotulo} style={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <span style={{ fontSize: 10, color: "var(--txt3)", textTransform: "uppercase", letterSpacing: 0.4 }}>
        {rotulo}
      </span>
      {children}
    </div>
  )
}
